export enum UserRole {
	ADMIN = 'admin',
	EDITOR = 'editor',
	VIEWER = 'viewer',
	GUEST = 'guest',
	CUSTOM = 'custom',
}
